/* eslint-disable no-unused-vars */
import { Delete, Get, Post, PostFormData, Put } from "../Request";

export default {
  state: {
    Currencies: [],
  },
  getters: {
    GetCurrencies(state) {
      return state.Currencies;
    },
  },
  actions: {
    async GetCurrencies({ commit }, payload) {
      return Get(`Currency/GetCurrencies`).then((res) => {
        commit("SetCurrencies", res.data.Data);
        return res.data;
      });
    },
  },
  mutations: {
    SetCurrencies(state, payload) {
      state.Currencies = payload;
    },
  },
};
